import React from 'react'
import { Box, Chip } from '@mui/material'

type FilterChipOptionKey = 'UNREAD' | 'ALL'

type FilterChipOption = {
    key: FilterChipOptionKey
    label: string
}

type FilterChipsProps = {
    options: FilterChipOption[]
    selectedKey: string
    onChange: (key: FilterChipOptionKey) => void
}

export const FilterChips = ({ options, selectedKey, onChange }: FilterChipsProps) => {
    return (
        <Box p={2} display="flex" gap={2}>
            {options.map(({ key, label }) => (
                <Chip
                    key={key}
                    onClick={() => onChange(key)}
                    color={selectedKey === key ? 'primary' : 'default'}
                    label={label}
                    sx={{ width: 'fit-content', cursor: 'pointer' }}
                />
            ))}
        </Box>
    )
}
